import { Component, input } from '@angular/core';
import { RootDirective, SvgDirective } from '@pure/hive';
import { EoneTierUpgradeRenderInfo } from '../../../../data/models/recommendations.models';
import { registerAsCardPlugin } from '../../services/recommendation-component-registry.service';

/** Stable registry key for this plugin. Used as the lookup name on the corresponding RenderInfo. */
export const EONE_TIER_UPGRADE_CARD_PLUGIN_NAME = 'EoneTierUpgradeCardPluginComponent';

/**
 * Plugin component for Evergreen//One tier upgrade recommendation card body.
 *
 * This component is "plugged into" the RecommendationCardTemplateComponent to provide
 * tier upgrade-specific content. The card template provides the shell (header, footer,
 * buttons), while this plugin provides the custom body content.
 *
 * To create a new recommendation type plugin, see: recommendations-container/README.md
 */
@Component({
    selector: 'eone-tier-upgrade-card-plugin',
    templateUrl: './eone-tier-upgrade-card-plugin.component.html',
    styleUrls: ['./eone-tier-upgrade-card-plugin.component.scss'],
    standalone: true,
    imports: [RootDirective, SvgDirective],
})
export class EoneTierUpgradeCardPluginComponent {
    renderInfo = input.required<EoneTierUpgradeRenderInfo>();
}

registerAsCardPlugin(EONE_TIER_UPGRADE_CARD_PLUGIN_NAME, EoneTierUpgradeCardPluginComponent);
